import {
  PageTitle,
  BottomButtons, ConfirmCheck, EmailForm, DhgateReviewItemList, DhgateReviewPanel, BPReviewPanel,
} from '@components';

import { NO_EMAIL_CHANNEL, ClaimType } from '@constants';
import classes from './index.module.css';
import { useReview } from './hooks';

const TITLE = 'Please review and finish';
const EMAIL_TITLE = 'Please add your email address to receive updates about your claim';

const Review = () => {
  const {
    type,
    // files,
    // files1,
    trackInfo,
    isConfirmed,
    reviewData,
    isLoading,
    platform,
    customEmail,
    onClickContinue,
    handleChange,
    handleEmailChange,
  } = useReview();
  return (
    <section className={classes.content}>
      <PageTitle title={TITLE} />
      {type === ClaimType.Delay ? <BPReviewPanel reviewInfo={reviewData} />
        : <DhgateReviewPanel reviewInfo={reviewData} type={type} />}
      {/* <ReviewItemList
        selectedPackageList={trackInfo.items}
        orderName={orderName}
        files={files}
        comments={comments}
        type={type}
        reasonList={reasonList}
        orderNameTitleText={platform === PLATFORM_NAME.SIDELINESWAP ? 'Swap' : 'Order'}
      /> */}
      <DhgateReviewItemList
        infoList={trackInfo}
      />
      {/* dhlink/shoplazza没有邮箱，这里必须要消费者填写邮箱来收取理赔邮件 */}
      {NO_EMAIL_CHANNEL.includes(platform) && <EmailForm onChange={handleEmailChange} title={EMAIL_TITLE} />}
      <ConfirmCheck checked={isConfirmed} onChange={handleChange} />
      <BottomButtons
        isContinueLoading={isLoading}
        isContinueDisabled={!(isConfirmed && customEmail)}
        continueText="Submit"
        showContinueIcon={false}
        onClickContinue={onClickContinue}
      />
    </section>
  );
};
export default Review;
